// extracted by mini-css-extract-plugin
export default {"subsection":"LaunchAttrsSection__subsection-W4FWM","appendUrlParamsCol":"LaunchAttrsSection__appendUrlParamsCol-cMgF8"};